export const getPageClass = ( location ) =>
{
    const nameAsMatch = location.pathname.match(/\/([a-zA-Z0-9-]+)/);
    if( nameAsMatch )
    {
        const nameAsString = nameAsMatch[1];

        return `getPageClass-equals-${nameAsString}`;
    }
    else
    {
        return '';
    }
};

export const showSearchBarOnThisPage = ( location ) =>
{
    // TODO: requests-me|requests-other|
    if( location.pathname.match(/\/(organizations|projects[/]?$|contacts|organizationPackageMapping)/))
    {
        return true;
    }
    else
    {
        return false;
    }
};

/**
 *
 * WHERE TO PUT THIS FUNCTION:
 *
 *      "Warning: setState(...): Cannot update during an existing state transition (such as within `render`
 *      or another component's constructor). Render methods should be a pure function of props and state;
 *      constructor side-effects are an anti-pattern, but can be moved to `componentWillMount`."
 *
 * @param location ... (passed)
 * @param searchBarAction ... wrapped with dispatch and getState
 */

let previousLocation = null;

export const processPotentialPageLocationChanges = ( location, searchBarAction ) =>
{
    let newLocation = location.pathname;
    let isChanged = previousLocation !== newLocation;
    // console.log( 'processPotentialPageLocationChanges','[[[ ');
    // console.log( 'processPotentialPageLocationChanges', {newLocation, previousLocation, isChanged});
    if( isChanged )
    {
        previousLocation = newLocation;

        /////// Put on page changed actions here
        searchBarAction({searchText:''});
        ///////
    }
    // console.log( 'processPotentialPageLocationChanges',']]]');
};





// WEBPACK FOOTER //
// ./src/Atollon/Page.js